
export default {
  props: {
    height: {
      type: [Number, String],
      default: '24px',
    },
    hint: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    max: {
      type: Number,
      default: 100,
    },
    min: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    thumbColor: {
      type: String,
      default: '#4E226E',
    },
    thumbLabel: {
      type: [Boolean, String],
      default: false,
    },
    thumbSize: {
      type: Number,
      default: 32,
    },
    ticks: {
      type: [Boolean, String],
      default: false,
    },
    tickLabels: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isHintExists() {
      return !!this.hint;
    },
    currentValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    absoluteMinValue() {
      return Math.abs(this.min);
    },
    isRangeWithNegativeNumber() {
      return this.min < 0;
    },
    calculateZeroPoint() {
      return `${((100 / (this.absoluteMinValue + this.max)) * this.absoluteMinValue).toFixed(4)}%`;
    },
    calculculatedDotZeroStyles() {
      return `left: calc(${this.calculateZeroPoint} - 1px);`;
    },
  },
  mounted() {
    if (this.isRangeWithNegativeNumber) {
      this.addZeroDot();
      this.addCustomFill();
      Array.from(this.$refs.slider.$refs.track.children)
        .filter((el) => el.tagName === 'DIV')
        .forEach((el) => {
          const elementToHide = el;
          elementToHide.style.display = 'none';
        });
      this.handleTrackFill();
    }
  },
  methods: {
    addZeroDot() {
      const zeroDot = document.createElement('span');
      zeroDot.classList.add('zero-dot');
      zeroDot.style.cssText += this.calculculatedDotZeroStyles;
      this.$refs.slider.$refs.track.prepend(zeroDot);
    },
    addCustomFill() {
      const customFill = document.createElement('span');
      customFill.classList.add('custom-fill');
      this.$refs.slider.$refs.track.prepend(customFill);
    },
    handleTrackFill() {
      const { track } = this.$refs.slider.$refs;
      const stepSize = 100 / (this.absoluteMinValue + this.max);
      const absoluteValue = Math.abs(this.value);
      track.firstElementChild.style.width = `${(stepSize * absoluteValue)}%`;
      if (this.value < 0) {
        track.firstElementChild.style.left = `${(this.absoluteMinValue - absoluteValue) * stepSize}%`;
      } else {
        track.firstElementChild.style.left = this.calculateZeroPoint;
      }
    },
  },
  watch: {
    value() {
      if (this.isRangeWithNegativeNumber) this.handleTrackFill();
    },
  },
};
